/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { spaceResultSearchFragment$ref } from "./spaceResultSearchFragment.graphql";
import type { FragmentReference } from "relay-runtime";
declare export opaque type spaceEventWithParams$ref: FragmentReference;
declare export opaque type spaceEventWithParams$fragmentType: spaceEventWithParams$ref;
export type spaceEventWithParams = {|
  +results: ?{|
    +resume: ?any,
    +spaces: ?$ReadOnlyArray<?{|
      +id: string,
      +$fragmentRefs: spaceResultSearchFragment$ref,
    |}>,
  |},
  +$refType: spaceEventWithParams$ref,
|};
export type spaceEventWithParams$data = spaceEventWithParams;
export type spaceEventWithParams$key = {
  +$data?: spaceEventWithParams$data,
  +$fragmentRefs: spaceEventWithParams$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "datesSelected"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "disposition"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lang"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "params"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "riders"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "spaceEventWithParams",
  "selections": [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Variable",
          "name": "params",
          "variableName": "params"
        }
      ],
      "concreteType": "SearchSpacesForMap",
      "kind": "LinkedField",
      "name": "searchSpaceByParams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resume",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "datesSelected",
                  "variableName": "datesSelected"
                },
                {
                  "kind": "Variable",
                  "name": "disposition",
                  "variableName": "disposition"
                },
                {
                  "kind": "Variable",
                  "name": "lang",
                  "variableName": "lang"
                },
                {
                  "kind": "Variable",
                  "name": "riders",
                  "variableName": "riders"
                }
              ],
              "kind": "FragmentSpread",
              "name": "spaceResultSearchFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '02e91c810607172b766b342b9975e965';

module.exports = node;
